import AuthorList from "./AuthorList"
import AuthorShow from "./AuthorShow"

const AuthorCRUD = {
  list: AuthorList,
  show: AuthorShow,
}

export default AuthorCRUD
